import * as React from 'react';

import { RegionalPromotionBanner } from 'bundles/front-page/components/banners/regional-promotion-banner/RegionalPromotionBanner';
import { getRegionalExperiment } from 'bundles/front-page/utils/regionalPromotions';
import { useCourseraPlusOwnership } from 'bundles/unified-description-page-common/contexts/consumer/CourseraPlusOwnershipContext';

type Props = {
  variant?: 'blue' | 'purple';
};

const RegionalPromotionBannerRenderer = ({ variant }: Props) => {
  const courseraPlusOwnership = useCourseraPlusOwnership();
  const { isCourseraPlusEligibleProduct, isSubscribedToCPlusOrLite } = courseraPlusOwnership || {};

  if (!isCourseraPlusEligibleProduct || isSubscribedToCPlusOrLite) {
    return null;
  }

  const regionalExperiment = getRegionalExperiment();

  if (!regionalExperiment) {
    return null;
  }

  return <RegionalPromotionBanner variant={variant} />;
};

export default RegionalPromotionBannerRenderer;
